<template>
  <div id="app" class="app-out">
    <router-view />
    <loginDialog />
    <register />

    <backToTop :showOnScrollTop="50" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import backToTop from '@/components/backToTop'
import register from '@/modules/common/user-out/register'
import loginDialog from '@/modules/common/user-out/login-dialog'

export default {
  name: 'App',
  components: {
    backToTop,
    register,
    loginDialog
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  watch: {
    '$route' (val) {
      this.getTitle(this.$route)
    }
  },
  created () {
    // 根据不同路由来改变页面title
    this.getTitle(this.$route)
  },
  mounted () {
    if (this.isLogin) {
      this.getUserInfo()
    }
  },
  methods: {
    ...mapActions({
      getUserInfo: 'getHistoryInfo'
    }),
    getTitle (route) {
      let title = route.query.title
      let name = route.name
      if (title) {
        document.title = `${decodeURIComponent(title)}_中国改革开放全纪录（1978-2018）_中国改革开放数据库`
        return true
      }
      switch (name) {
        case 'chronologySearch': document.title = '编年检索_中国改革开放全纪录（1978-2018）_中国改革开放数据库'
        break
        case 'fullLibSearch': document.title = '全库检索_中国改革开放全纪录（1978-2018）_中国改革开放数据库'
        break
        case 'aboutUs': document.title = '版权声明'
        break
        default: document.title = '中国改革开放全纪录（1978-2018）_中国改革开放数据库'
        break
      }
    }
  }
}
</script>

<style src="./style/index.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/App.out.vue